import * as info from './api-services/info.js'
export default{
    info,

}